import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { NumberInput } from "shared/ui/input/number/NumberInput"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface RoomSoundPressureLevelCustomInputProps extends WithClassName {}

export const RoomSoundPressureLevelCustomInput = React.memo(
  ({ className }: RoomSoundPressureLevelCustomInputProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled } = useRoomFormContext()

    return (
      <NumberInput.Root
        name="room.soundPressureLevel"
        label={t("Room.soundPressureLevel")}
        unit="dB(A)"
        className={classNames(
          "room-form__sound-pressure-level-custom",
          { "room-form__sound-pressure-level-custom--readonly": isReadonly },
          className
        )}
        readonly={isReadonly}
        disabled={isDisabled}
        format={{ maximumFractionDigits: 0 }}
        step={1}
        min={0}
        max={100}
        data-testid="room__sound-pressure-level__input"
      >
        <NumberInput.Label showUnit />
        {isReadonly ? null : (
          <NumberInput.InfoMessage>
            {t("Room.soundPressureLevelCustom")}
          </NumberInput.InfoMessage>
        )}
        <NumberInput.Group>
          <NumberInput.Decrement />
          <NumberInput.Focus>
            <NumberInput.Affix>≤</NumberInput.Affix>
            <NumberInput.Input />
          </NumberInput.Focus>
          <NumberInput.Increment />
        </NumberInput.Group>
        <NumberInput.Readonly render={value => `≤ ${value}`} />
        <NumberInput.ErrorMessage />
      </NumberInput.Root>
    )
  }
)
